import React from 'react';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';
import { format } from 'date-fns';

const { FiClock, FiAlertTriangle, FiCheckCircle, FiShield, FiFileText } = FiIcons;

const EmergencyEventHistory = () => {
  const events = [
    {
      id: 'EVT-4422-01',
      type: 'Hypertensive Breach',
      severity: 'critical',
      timestamp: new Date(Date.now() - 172800000), // 2 days ago
      status: 'Resolved',
      data: 'BP 188/112 | HR 102',
      action: 'Emergency Dispatch Initiated'
    },
    {
      id: 'EVT-4422-02',
      type: 'Tachycardia Warning',
      severity: 'high',
      timestamp: new Date(Date.now() - 432000000), // 5 days ago
      status: 'Resolved',
      data: 'HR 165 | Activity: Still',
      action: 'Caregiver Notification Sent'
    }
  ];

  return (
    <div className="bg-white p-10 rounded-[3rem] border border-gray-100 shadow-xl">
      <div className="flex items-center justify-between mb-10">
        <div>
          <h3 className="text-2xl font-black text-gray-900 tracking-tight">Protocol History</h3>
          <p className="text-sm text-gray-400 font-bold uppercase tracking-widest mt-1">Audit Log: Emergency Events</p>
        </div>
        <div className="p-4 bg-red-50 text-red-600 rounded-3xl">
          <SafeIcon icon={FiClock} className="text-2xl" />
        </div>
      </div>

      <div className="space-y-6">
        {events.map((event, idx) => (
          <motion.div 
            key={event.id}
            initial={{ opacity: 0, x: -20 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ delay: idx * 0.1 }}
            className="p-8 bg-gray-50/50 rounded-[2rem] border border-gray-100 hover:bg-white hover:shadow-lg transition-all"
          >
            <div className="flex flex-col md:flex-row md:items-center justify-between gap-6">
              <div className="flex items-start space-x-6">
                <div className={`w-14 h-14 rounded-2xl flex items-center justify-center ${event.severity === 'critical' ? 'bg-red-600 text-white shadow-lg shadow-red-200' : 'bg-orange-500 text-white'}`}>
                  <SafeIcon icon={FiAlertTriangle} className="text-2xl" />
                </div>
                <div>
                  <div className="flex items-center space-x-3 mb-1">
                    <h4 className="text-lg font-black text-gray-900">{event.type}</h4>
                    <span className="text-[10px] font-black text-gray-400 uppercase tracking-widest">{event.id}</span>
                  </div>
                  <p className="text-sm font-bold text-gray-500 mb-4">{format(event.timestamp, 'MMM d, yyyy • HH:mm')}</p>
                  
                  <div className="flex flex-wrap gap-3">
                    <span className="px-4 py-2 bg-white rounded-xl text-[10px] font-black text-gray-900 border border-gray-100 uppercase tracking-widest flex items-center">
                      <SafeIcon icon={FiActivity} className="mr-2 text-cyan-500" />
                      {event.data}
                    </span>
                    <span className="px-4 py-2 bg-white rounded-xl text-[10px] font-black text-gray-900 border border-gray-100 uppercase tracking-widest flex items-center">
                      <SafeIcon icon={FiShield} className="mr-2 text-green-500" />
                      {event.action}
                    </span>
                  </div>
                </div>
              </div>
              
              <div className="flex items-center space-x-3">
                <div className="text-right mr-4">
                  <p className="text-[10px] font-black text-gray-400 uppercase tracking-widest mb-1">Status</p>
                  <p className="text-sm font-black text-green-600 uppercase">{event.status}</p>
                </div>
                <button className="w-12 h-12 bg-white text-gray-400 rounded-2xl border border-gray-100 flex items-center justify-center hover:text-cyan-600 transition-colors">
                  <SafeIcon icon={FiFileText} />
                </button>
              </div>
            </div>
          </motion.div>
        ))}
      </div>
    </div>
  );
};

export default EmergencyEventHistory;